/*!
 * MUU v1.1.14
 * Unified UI framework for MaiHaoChe.com
 * https://maihaoche.github.io/muu/
 *
 * Copyright 2017, Ourai Lin <ourairyu@gmail.com> (http://ourai.ws/)
 * Released under the MIT license.
 *
 * 00000000000000000000000000000000000000000000000000
 * 000000000000000000000GCft1tf1tLC000000000000000000
 * 00000000000000000LLf1i1i;t1t11i1itL000000000000000
 * 000000000000000Cf111t1;ttf1tt1if11;tfC000000000000
 * 0000000000000Ciiif11;11111iitf1f1ffftitL0000000000
 * 000000000000Ci1ti11i;1i11ti1i1;i1iit1iitG000000000
 * 000000000000t;iii1i1;11tt;1ii;1iiii11ti1G000000000
 * 0000000000Gf1i:;;ii;;;;1;i:1it;11i1tti:f8000000000
 * 00000000008ti;:;ii1tfti;;;1;ii1ii:11iiCG0000000000
 * 00000000000Git;f1f1fif1;i1t:;i;1:i;:;;800000000000
 * 00000000000C:1f;t;tt11;:tfC1:tt1;i::;:G00000000000
 * 000000000008i;i1fti;:ittCfftf:i1;ti;;;180000000000
 * 0000000000008fft1ff1tittttLGL.Li1;;1;ii80000000000
 * 000000000000CfLG800Gft1tffLLLLftt1::i;;C0000000000
 * 000000000000Li00GCCGGGf1LLfCCfi1tt1;11;G0000000000
 * 0000000000000;G80080008t1CfLtt;iff1;1if00000000000
 * 0000000000008i1LLCftG08011ttt1ttfff:ii;00000000000
 * G000000000000CL11ttCtfftfi1i;ifi1;1iL;C00000000000
 * 00G0G000000000000GLtfCG8i;:;1i;1if1fLfC00000000000
 * GGGGGGGG0000000000000G;tt:ii;1ftCLffLt1G0000000000
 * GGGGGGGGGG00000000000i;;i;ittLftLtf1t;;;L000000000
 * GGGGGGGGGGGGGGGGGG00:i;;i11ifLftft;ii1tLif000000G0
 * GGGGGGGGGGGGGGGGGGG0Lt;t;f1tfi;;;:itGCCitt:1C00GGG
 * GGGGGGGGGGGGGGGGGGGGG0i11:1:i:;1tCCCCGiGiCi::f0GGG
 * GGGGGGGGGGGGGGGGGGGGGf;,i1;:tLCffCLCf,tCCi1fi,fGGG
 */

;(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.muu = factory();
  }
}(this, function() {
"use strict";

var defaults = {};
var utils = {};

var SUPPORTS = {
  BS_MODAL: function BS_MODAL() {
    return hasOwnProp($.fn, "modal");
  },
  BS_TABLE: function BS_TABLE() {
    return hasOwnProp($.fn, "bootstrapTable");
  },
  BS_DATETIME: function BS_DATETIME() {
    return hasOwnProp($.fn, "datetimepicker");
  },
  SELECT2: function SELECT2() {
    return hasOwnProp($.fn, "select2");
  },
  H5FX: function H5FX() {
    return hasOwnProp(window, "H5F");
  },
  MOMENTJS: function MOMENTJS() {
    return hasOwnProp(window, "moment");
  }
};

function isFunction(target) {
  return $.isFunction(target);
}

function isString(target) {
  return $.type(target) === "string";
}

function isArray(target) {
  return $.isArray(target);
}

function inArray(target, arr) {
  return $.inArray(target, arr) > -1;
}

function toArray(target) {
  return [].slice.call(target);
}

function arrayEach(arr, callback) {
  if (isArray(arr)) {
    if (isFunction(arr.forEach)) {
      arr.forEach(callback);
    } else if (isFunction(callback)) {
      $.each(arr, function (idx, val) {
        callback.apply(val, [val, idx, arr]);
      });
    }
  }
}

function arrayMap(arr, callback) {
  return isArray(arr) ? $.map(arr, callback) : [];
}

function arrayFilter(arr, callback) {
  var newArr = [];

  if (isArray(arr)) {
    if (isFunction(arr.filter)) {
      newArr = arr.filter(callback);
    } else if (isFunction(callback)) {
      $.each(arr, function (idx, val) {
        if (callback.apply(val, [val, idx, [].concat(arr)])) {
          newArr.push(val);
        }
      });
    }
  }

  return newArr || [];
}

function objectKeys(obj) {
  var arr = [];

  if (isFunction(Object.keys)) {
    arr = Object.keys(obj);
  } else if ($.isPlainObject(obj)) {
    $.each(obj, function (key) {
      arr.push(key);
    });
  }

  return arr;
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var helpers = { isFunction: isFunction, isString: isString, isArray: isArray, hasOwnProp: hasOwnProp };

try {
  Object.defineProperty(utils, "helper", {
    value: helpers,
    writable: false,
    enumerable: false,
    configurable: false
  });
} catch (e) {
  utils.helper = helpers;
}

var bizData = {};

function resolveRefKeys(str) {
  return isString(str) && new RegExp("^[0-9a-z_]+(\.[0-9a-z_]+)*$", "i").test(str) ? str.split(".") : [];
}

utils.set = function (key, val) {
  var keys = resolveRefKeys(key);

  if (arguments.length < 2 || keys.length === 0) {
    return;
  }

  var lastKey = keys.pop();
  var tmp = bizData;

  arrayEach(keys, function (k) {
    if (!hasOwnProp(tmp, k)) {
      tmp[k] = {};
    }

    tmp = tmp[k];
  });

  tmp[lastKey] = val;

  return val;
};

utils.get = function (key) {
  var keys = resolveRefKeys(key);

  if (keys.length === 0) {
    return;
  }

  var idx = 0;
  var keyLength = keys.length;
  var tmp = $.extend(true, {}, bizData);
  var val = void 0,
      k = void 0;

  for (; idx < keyLength; idx++) {
    k = keys[idx];
    val = tmp[k];

    if (!hasOwnProp(tmp, k)) {
      break;
    }

    tmp = val;
  }

  return val;
};

utils.setDefaults = function (settings) {
  $.extend(true, defaults, settings);
};

utils.alert = function (message, settings) {
  var type = void 0,
      formatter = void 0;

  if (isString(settings)) {
    type = settings;
  } else if ($.isPlainObject(settings)) {
    type = settings.type;
    formatter = settings.formatter;
  }

  if (type === "bootstrap") {
    var $m = $(".js-alertSystemMessage");

    if ($m.length === 0) {
      $m = $("\n          <div class=\"modal fade js-alertSystemMessage\">\n            <div class=\"modal-dialog\">\n              <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button>\n                  <h4 class=\"modal-title\">\u7CFB\u7EDF\u63D0\u793A</h4>\n                </div>\n                <div class=\"modal-body\"></div>\n                <div class=\"modal-footer\">\n                  <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">\u5173\u95ED</button>\n                </div>\n              </div>\n            </div>\n          </div>\n        ");

      $("body").append($m);
    }

    if (!isFunction(formatter)) {
      formatter = function formatter(message) {
        return "<p class=\"u-textBreak\">" + message + "</p>";
      };
    }

    $(".modal-body", $m).html(formatter.call(null, message) || message);

    $m.modal("show");
  } else {
    alert(message);
  }
};

utils.$el = {
  triggerType: function triggerType($el) {
    return $el.attr("class").match(/js\-([a-zA-Z]+)/)[1];
  }
};

function filterUnchanged(data, raw, excluded) {
  var filtered = {};

  if ($.isPlainObject(data)) {
    if ($.isPlainObject(raw)) {
      if (!isArray(excluded)) {
        excluded = [];
      }

      $.each(data, function (k, v) {
        if (excluded.length > 0 && inArray(k, excluded) || v !== raw[k]) {
          filtered[k] = v;
        }
      });
    } else {
      filtered = data;
    }
  }

  return filtered;
}

utils.data = {
  changed: filterUnchanged
};

defaults.ajax = {
  waitingText: "数据保存中，请耐心等待...",
  errorHandler: function errorHandler(evt, req, settings, err) {
    var code = req.status;

    if (code >= 500) {
      utils.alert("服务器开小差啦～");
    } else if (code >= 400) {
      utils.alert(req.responseText);
    }
  },
  responseHandler: function responseHandler(res, callback, settings) {
    callback.apply(null, [res, settings]);
  }
};

function resetWaitStatus() {
  $(".modal:visible .js-waitForResult:visible").each(function () {
    var $layer = $(this);
    var $modal = $layer.closest(".modal");

    $layer.hide();
    $modal.removeClass("is-waiting");
    $("button", $(".modal-header, .modal-footer", $modal)).prop("disabled", false);
  });
}

function httpReq(url, method, params, callback, isJson, settings) {
  var ajaxOpts = {
    url: url,
    type: method,
    success: function success(res) {
      resetWaitStatus();

      utils.ajax.result(res, function (result) {
        if (isFunction(callback)) {
          callback.call(null, result, res);
        }
      }, settings);
    }
  };

  params = $.isPlainObject(params) ? params : utils.form.jsonify(params);

  if (isJson === true) {
    ajaxOpts.data = JSON.stringify(params);
    ajaxOpts.contentType = "application/json; charset=UTF-8";
  } else {
    if (inArray(method, ["get", "delete"])) {
      if (objectKeys(params).length) {
        ajaxOpts.url += "?" + arrayMap(objectKeys(params), function (k) {
          return k + "=" + encodeURIComponent(params[k]);
        }).join("&");
      }
    } else {
      ajaxOpts.data = params;
    }
  }

  return $.ajax(ajaxOpts);
}

utils.ajax = {
  result: function result(res, callback, settings) {
    if (!$.isPlainObject(settings)) {
      settings = {};
    }

    if (!hasOwnProp(settings, "alertType")) {
      settings.alertType = "system";
    }

    defaults.ajax.responseHandler(res, callback, settings);
  },
  waiting: function waiting($target) {
    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults.ajax.waitingText;

    var $dlg = $target.closest(".modal");

    if ($dlg.length) {
      $dlg.addClass("is-waiting");

      if ($(".js-waitForResult", $dlg).length) {
        $(".js-waitForResult", $dlg).show();
      } else {
        $(".modal-body", $dlg).append("<div class=\"Layer Layer--loading js-waitForResult\"><p>" + text + "</p></div>");
      }

      $("button", $(".modal-header, .modal-footer", $dlg)).prop("disabled", true);
    }
  }
};

arrayEach(["get", "post", "put", "delete"], function (method) {
  utils.ajax[method] = function (url, params, callback, isJson) {
    var $waiting = void 0,
        waitingText = void 0,
        alertType = void 0;

    if ($.isPlainObject(url)) {
      var opts = url;

      url = opts.url;
      params = opts.data;
      callback = opts.callback;
      isJson = opts.isJson;

      $waiting = opts.$waiting;
      waitingText = opts.waitingText;

      alertType = opts.alertType;
    } else {
      if (isFunction(params)) {
        isJson = callback;
        callback = params;
        params = {};
      }
      else if ($.isPlainObject(callback)) {
          $waiting = callback.$waiting;
          waitingText = callback.waitingText;

          alertType = callback.alertType;

          isJson = callback.isJson;
          callback = callback.callback;
        }
        else if ($.isPlainObject(isJson)) {
            $waiting = isJson.$waiting;
            waitingText = isJson.waitingText;

            alertType = isJson.alertType;

            isJson = isJson.isJson;
          }
    }

    if ($waiting) {
      utils.ajax.waiting($waiting, waitingText);
    }

    if (alertType == null) {
      alertType = "system";
    }

    return httpReq(url, method, params, callback, isJson, { alertType: alertType });
  };
});


function getMoveDigit(a, b) {
  var _a = void 0,
      _b = void 0,
      la = void 0,
      lb = void 0;

  a = a.toString(10);
  b = b.toString(10);

  _a = a.split(".");
  _b = b.split(".");

  la = _a.length === 2 ? _a[1].length : 0;
  lb = _b.length === 2 ? _b[1].length : 0;

  return Math.max(la, lb);
}

function move2Right(num, digit) {
  var str = void 0,
      _num = void 0;

  if (digit === 0) {
    return num;
  }

  num = num.toString(10);
  _num = num.split(".");
  str = _num[1] ? _num[1] : "";
  _num = _num[0];

  for (var i = 0; i < digit; i++) {
    _num += str[i] ? str[i] : "0";
  }

  return _num * 1;
}

function move2Left(num, digit) {
  if (digit === 0) {
    return num;
  }

  var arr = void 0,
      len = void 0;

  num = num.toString();
  arr = num.split(".");

  if (arr.length === 2) {
    digit += arr[1].length;
    num = num.replace(".", "");
  }

  arr = num.split("");
  len = num.length;

  for (var i = 0; i < digit - len; i++) {
    arr.unshift("0");
  }

  arr.splice(arr.length - digit, 0, ".");

  return arr.join("") * 1;
}

utils.calculate = {
  plus: function plus(a, b) {
    var d = getMoveDigit(a, b);

    return move2Left(move2Right(a, d) + move2Right(b, d), d);
  },
  minus: function minus(a, b) {
    var d = getMoveDigit(a, b);

    return move2Left(move2Right(a, d) - move2Right(b, d), d);
  },
  multiply: function multiply(a, b) {
    var d = getMoveDigit(a, b);

    return move2Left(move2Right(a, d) * move2Right(b, d), d * 2);
  },
  divided: function divided(a, b) {
    var d = getMoveDigit(a, b);

    return move2Left(move2Right(a, d) / move2Right(b, d), d);
  },
  move2Left: move2Left,
  move2Right: move2Right,
  getMoveDigit: getMoveDigit
};

var dialogLevel = 0;
var DIALOG_DEFAULT_INDEX = 1050;

utils.dialog = {
  init: function init($dlg, opts) {
    if ($.isPlainObject($dlg)) {
      opts = $dlg;
      $dlg = $(".js-addNewData");
    }

    if (!$($dlg).is(".modal")) {
      return;
    }

    var $form = $("form", $dlg);

    if ($form.length !== 1) {
      return;
    }

    utils.form.h5f($form);

    if (!$.isPlainObject(opts)) {
      opts = {};
    }

    if (!hasOwnProp(opts, "$btn") && $dlg.is(".js-addNewData")) {
      opts.$btn = $(".js-saveNewData");
    }

    if ($(opts.$btn).length > 0) {
      opts.$btn.on("click", function () {
        $form.trigger("submit");
      });
    }

    $form.on({
      "H5F:submit": function H5FSubmit(evt, inst, submitEvt) {
        if (isFunction(opts.onFormSubmit)) {
          opts.onFormSubmit.apply(this, [evt, utils.form.jsonify($form), inst, submitEvt]);
        }

        submitEvt.preventDefault();

        return false;
      },
      "reset": function reset() {
        if (isFunction(opts.onFormReset)) {
          opts.onFormReset.apply(this, arguments);
        }
      }
    });

    $dlg.on("hidden.bs.modal", function () {
      $form.trigger("reset");
      $dlg.removeClass("is-editing is-viewing");

      if (isFunction(opts.onModalHide)) {
        opts.onModalHide.apply(this, arguments);
      }
    });

    return $dlg;
  },
  levelUp: function levelUp($dlg) {
    var $backdrop = $dlg.data("bs.modal").$backdrop;
    var increase = dialogLevel * 2 * 10;

    $dlg.css("z-index", DIALOG_DEFAULT_INDEX + increase);

    if ($backdrop) {
      $backdrop.css("z-index", DIALOG_DEFAULT_INDEX + increase - 10);
    }

    dialogLevel++;
  },
  levelDown: function levelDown($dlg) {
    var $backdrop = $dlg.data("bs.modal").$backdrop;

    $dlg.css("z-index", DIALOG_DEFAULT_INDEX);

    if ($backdrop) {
      $backdrop.css("z-index", DIALOG_DEFAULT_INDEX - 10);
    }

    dialogLevel--;
  },
  top: function top() {
    return [].sort.call($(".modal:visible"), function (a, b) {
      return $(a).css("z-index") * 1 < $(b).css("z-index") * 1;
    }).first();
  }
};

defaults.form = {
  filter: function filter(data, $field, arr) {
    return true;
  },
  serializer: function serializer(arr) {
    return arr;
  }
};

function getDefaultOptions($sel) {
  return arrayFilter($("option", $sel).toArray(), function (opt) {
    return opt.defaultSelected === true;
  });
}

utils.select = {
  change: function change($sel, val, callback) {
    var opts = void 0;

    if (val == null || val === "") {
      opts = getDefaultOptions($sel);
    } else {
      if (isString(val) && val.split(",")) {
        val = val.split(",");
      }

      opts = isArray(val) ? arrayMap(val, function (v) {
        return $("option[value='" + v + "']", $sel);
      }) : $("option[value='" + val + "']", $sel);
    }

    $(":selected", $sel).prop("selected", false);

    arrayEach($(opts).toArray(), function (opt) {
      $(opt).prop("selected", true);
    });

    if (isFunction(callback)) {
      callback.call($sel.get(0));
    }

    $sel.trigger("change");

    return $sel;
  }
};

function isQueryStr(str) {
  return isString(str) && str.split("&").length > 0 && str.split("&")[0].split("=").length > 0;
}

function queryStr2SerializedArr(str) {
  return arrayMap(str.split("&"), function (pair) {
    var p = pair.split("=");

    return {
      name: p[0],
      value: decodeURIComponent(p[1])
    };
  });
}

function jsonifyFormData($form, callback) {
  var jsonData = {};

  arrayEach(isArray($form) ? $form : isQueryStr($form) ? queryStr2SerializedArr($form) : $($form).serializeArray(), function (p) {
    jsonData[p.name] = hasOwnProp(jsonData, p.name) ? [].concat(jsonData[p.name], p.value) : p.value;
  });

  if (isFunction(callback)) {
    var newJson = callback(jsonData);

    if ($.isPlainObject(newJson)) {
      jsonData = newJson;
    }
  }

  return jsonData;
}

function resetValidateStatus() {
  var $form = $(this);

  $(".form-group", $form).removeClass("has-success has-error");
  $(".help-block:not(.is-dynamic)", $form).removeClass("u-hidden");
  $(".help-block.is-dynamic, .Error, .ErrorGroup", $form).addClass("u-hidden");
}

utils.form = {
  h5f: function h5f($form) {
    H5F.init($form, { immediate: false });

    $("[name]", $form).on({
      "H5F:valid": function H5FValid(e, f) {
        var $cell = $(e.target).closest("div");
        var $group = $cell.closest(".form-group");
        var errSelector = void 0;

        if ($group.length > 0) {
          errSelector = ".help-block[data-name=\"" + f.name + "\"]";

          $(".help-block:not(.is-dynamic)", $group).addClass("u-hidden");
          $group.removeClass("has-error").addClass("has-success");
        } else {
          errSelector = ".Error[data-name=\"" + f.name + "\"]";
          $group = $(".ErrorGroup", $cell);
        }

        $(errSelector, $cell).addClass("u-hidden");

        if ($group.is(".ErrorGroup") && $(".Error:not(.u-hidden)", $group).length === 0) {
          $group.addClass("u-hidden");
        }
      },
      "H5F:invalid": function H5FInvalid(e, f) {
        var $cell = $(e.target).closest("div");
        var $group = $cell.closest(".form-group");
        var $container = void 0,
            errSelector = void 0,
            errHtml = void 0;

        if ($group.length > 0) {
          errSelector = ".help-block[data-name=\"" + f.name + "\"]";
          errHtml = "<p class=\"help-block is-dynamic\" data-name=\"" + f.name + "\" />";
          $container = $cell;

          $(".help-block:not(.is-dynamic)", $container).addClass("u-hidden");
          $group.removeClass("has-success").addClass("has-error");
        } else {
          errSelector = ".Error[data-name=\"" + f.name + "\"]";
          errHtml = "<p class=\"Error\" data-name=\"" + f.name + "\" />";
          $container = $(".ErrorGroup", $cell);

          if ($container.length > 0) {
            $container.removeClass("u-hidden");
          } else {
            $cell.append("<div class=\"ErrorGroup\" />");
            $container = $(".ErrorGroup", $cell);
          }
        }

        var $err = $(errSelector, $container);

        if ($err.length === 0) {
          $container.append(errHtml);
          $err = $(errSelector, $container);
        }

        $err.text(f.message).removeClass("u-hidden");
      }
    });

    $form.on("reset", resetValidateStatus);
  },
  fill: function fill($form, data) {
    if (!$.isPlainObject(data)) {
      return;
    }

    $("[name]", $form).each(function () {
      var $ipt = $(this);
      var tagName = this.tagName.toLowerCase();
      var key = $ipt.attr("name");
      var value = data[key];

      if (inArray(tagName, ["input", "textarea"])) {
        if (inArray($ipt.attr("type"), ["radio", "checkbox"])) {
          $("[name=\"" + key + "\"][value=\"" + value + "\"]", $form).prop("checked", true);
        } else {
          $ipt.val(value);
        }
      } else if (tagName === "select") {
        utils.select.change($ipt, value);
      }
    });
  },
  reset: function reset($form, callback) {
    $("select", $form).each(function () {
      utils.select.change($(this));
    });

    $("[type='hidden']", $form).val("");

    if (isFunction(callback)) {
      callback.call($form.get(0));
    }
  },
  jsonify: jsonifyFormData,
  serialize: function serialize($form, filter) {
    var settings = $form;
    var serializer = void 0;

    if ($.isPlainObject($form)) {
      $form = settings.$form;
      filter = settings.filter;
      serializer = settings.serializer;
    }

    if (!isFunction(filter)) {
      filter = defaults.form.filter;
    }

    if (!isFunction(serializer)) {
      serializer = defaults.form.serializer;
    }

    $form = $($form);

    return serializer(arrayFilter($form.serializeArray(), function (data, idx, arr) {
      return filter(data, $("[name=\"" + data.name + "\"]", $form), arr);
    }));
  }
};

utils.field = {
  fill: function fill($container, data, callback) {
    if (!$.isPlainObject(data)) {
      return;
    }

    $("[data-field]", $container).each(function () {
      var $f = $(this);
      var val = data[$f.attr("data-field")];

      if ($f.is("img")) {
        $f.attr("src", val);
      } else {
        $f.text(val || "-");
      }

      if (isFunction(callback)) {
        callback.apply(this, [$f.attr("data-field"), val]);
      }
    });
  },
  datepicker: function datepicker() {
    var $picker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(".js-pickDate");
    var opts = arguments[1];

    $picker.each(function () {
      var $p = $(this);
      var $ipt = $("[name=\"" + $p.attr("data-to") + "\"]", $p.closest("form"));

      $p.datepicker($.extend({
        language: "zh-CN",
        autohide: true
      }, $ipt.length ? {
        pick: function pick() {
          $ipt.val(moment($(this).datepicker("getDate")).format());
        }
      } : null, opts));

      if ($ipt.length) {
        $p.on("change", function () {
          if ($(this).val() === "") {
            $ipt.val("");
          }
        });
      }
    });
  },
  datetimepicker: function datetimepicker($picker, opts) {
    if ($.isPlainObject($picker)) {
      opts = $picker;
      $picker = null;
    }

    $picker = $picker == null ? $(".js-pickDateTime") : $($picker);
    opts = $.extend(true, {}, opts);

    $picker.each(function () {
      var $p = $(this);

      if ($p.is(".js-pickDatePeriod")) {
        var selector = "input:not([type='hidden'])";
        var $ipts = $(selector, $p);

        if ($ipts.length === 2) {
          $ipts.each(function (idx) {
            var $ipt = $(this);
            var method = void 0;

            if (idx === 0) {
              method = "minDate";
            } else {
              method = "maxDate";
              opts.useCurrent = false;
            }

            $ipt.datetimepicker(opts).on("dp.change", function (evt) {
              var $dt = $(this);
              var date = evt.date;

              $dt.siblings(selector).data("DateTimePicker")[method](date);
              $("input[name='" + $dt.attr("data-to") + "']", $dt.closest("form")).val(moment(date).format());
            });
          });
        }
      }
      else {
          $p.datetimepicker(opts);
        }
    });
  }
};

defaults.generator = {
  imageColumnCount: 3
};

function isImageItemOverflow($btn, limit) {
  return $(".ImageItem:not(.ImageItem--add)", $btn.closest(".ImageList").parent()).length >= limit;
}

function insertImageItem(opts) {
  var $btn = $(opts.$btn);
  var maxCount = opts.max;

  if (!$btn.is(".ImageItem") || maxCount && isImageItemOverflow($btn, maxCount)) {
    return;
  }

  var columnCount = Number(opts.column);

  if (isNaN(columnCount) || columnCount <= 0) {
    columnCount = defaults.generator.imageColumnCount;
  }

  var listCls = "ImageList";
  var itemCls = "ImageList-item";

  var $btnCol = opts.$btn.closest("." + itemCls);
  var $newCol = $("<div class=\"" + itemCls + " col-sm-" + 12 / columnCount + " is-dynamic\" />");

  $newCol.html(utils.generate.image(opts.url, opts.text, opts.removable));
  $btnCol.before($newCol);

  if (isFunction(opts.callback)) {
    opts.callback.call(null, $newCol, $btnCol);
  }

  var imageItemSize = $btnCol.siblings("." + itemCls).length;

  if (imageItemSize === columnCount) {
    $("." + listCls + ":last", opts.$el).after("<div class=\"" + listCls + " row\" />");
    $("." + listCls + ":last", opts.$el).append($btnCol);
  }

  if (maxCount) {
    var $btnRow = $btnCol.closest("." + listCls);
    var hiddenCls = "u-hidden";

    $btn.data("muu.imageItemMax", maxCount);

    $("." + listCls + "." + hiddenCls + ", ." + itemCls + "." + hiddenCls, $btnRow.parent()).removeClass(hiddenCls);

    if (isImageItemOverflow($btnRow, maxCount)) {
      $btnCol.addClass(hiddenCls);

      if (imageItemSize === 0) {
        $btnRow.addClass(hiddenCls);
      }
    }
  }

  return $newCol;
}

function moveImageItemsForward($item) {
  var listCls = "ImageList";
  var itemCls = "ImageList-item";
  var hiddenCls = "u-hidden";

  var $list = $item.closest("." + listCls);
  var $container = $list.parent();

  $("." + listCls + ":gt(" + $("." + listCls, $container).index($list) + ")", $container).each(function () {
    var $r = $(this);

    $r.prev("." + listCls).append($("." + itemCls + ":first", $r));

    if ($("." + itemCls, $r).length === 0) {
      $r.remove();
    }
  });

  $item.closest("." + itemCls).remove();

  var $btn = $(".ImageItem--add", $container);
  var maxCount = $btn.data("muu.imageItemMax");

  if (maxCount) {
    var $btnCol = $btn.closest("." + itemCls);

    $("." + listCls + "." + hiddenCls, $container).removeClass(hiddenCls);

    if (!isImageItemOverflow($btn, maxCount)) {
      $btnCol.removeClass(hiddenCls);
    } else if ($btnCol.siblings("." + itemCls).length === 0) {
      $btnCol.closest("." + listCls).addClass(hiddenCls);
    }
  }
}

function generateMainTrigger(opts) {
  var triggerCls = opts.btnCls.concat("js-" + opts.action);
  var isLink = isString(opts.url);
  var html = [];

  if (isLink) {
    html.push("<a href=\"" + opts.url + "\" title=\"" + opts.text + "\"" + (opts.isExternal === true ? "target=\"_blank\"" : ""));
  } else {
    html.push("<button type=\"button\" title=\"" + opts.text + "\"");
  }

  if (opts.hasChildren && opts.isSplit !== true) {
    triggerCls.push("dropdown-toggle");
    html.push(" data-toggle=\"dropdown\"");
  }

  html.push(" class=\"" + triggerCls.join(" ") + "\">");

  html.push(isString(opts.icon) ? "<i class=\"Operation-icon fa fa-" + opts.icon + " fa-fw\"></i><span class=\"" + (opts.isCoexisted === true ? "Operation-label" : "sr-only") + "\">" + opts.text + "</span>" : opts.text);

  if (opts.hasChildren && opts.isSplit !== true) {
    html.push("<span class=\"caret\"></span>");
  }

  html.push("</" + (isLink ? "a" : "button") + ">");

  return html.join("");
}

function generateSubItem(item) {
  return "<li><a class=\"js-" + item.action + "\" href=\"" + (isString(item.url) ? item.url : "javascript:void(0);") + "\"" + (item.isExternal === true ? "target=\"_blank\"" : "") + ">" + item.text + "</a></li>";
}

function generateDropdownMenu(opts) {
  var html = [];

  if (opts.isSplit === true) {
    html.push("<button type=\"button\" class=\"" + opts.btnCls.concat("dropdown-toggle").join(" ") + "\" data-toggle=\"dropdown\"><span class=\"caret\"></span></button>");
  }

  html.push("<ul class=\"Operation-menu dropdown-menu dropdown-menu-right\">");

  html.push(arrayMap(opts.actions, function (child, idx) {
    var isGrouped = isArray(child);
    var items = isGrouped ? arrayMap(child, function (groupedChild) {
      return generateSubItem(groupedChild);
    }).join("") : generateSubItem(child);

    if (idx > 0 && isGrouped) {
      items = "<li class=\"divider\"></li>" + items;
    }

    return items;
  }).join(""));

  html.push("</ul>");

  return html.join("");
}

utils.generate = {
  image: function image(url, alt, removable) {
    var html = [];

    alt = alt || "";

    html.push("<figure class=\"ImageItem\"><div><a href=\"" + (url || "javascript:void(0);") + "\" target=\"_blank\"><img src=\"" + (url || "") + "\" alt=\"" + alt + "\" title=\"" + alt + "\"></a></div>");

    if (alt) {
      html.push("<figcaption class=\"u-textTruncate\" title=\"" + alt + "\">" + alt + "</figcaption>");
    }

    if (removable === true) {
      html.push("<button type=\"button\" class=\"ImageItem-button fa fa-close js-removeUploadedImage\" title=\"\u5220\u9664\"><span class=\"sr-only\"></span></button>");
    }

    html.push("</figure>");

    return html.join("");
  },
  imageItem: insertImageItem,
  action: function action(actions, wrapped) {
    if ($.isPlainObject(actions)) {
      actions = [actions];
    }

    actions = actions.concat(defaults.table.rowActions);

    if (!isArray(actions)) {
      return false;
    }

    var html = arrayMap(actions, function (a) {
      if ($.isPlainObject(a)) {
        var btnHtml = [];
        var btnCls = ["Operation", "btn", "btn-" + (a.isPrimary === true ? "primary" : a.isDelete === true ? "danger" : "default"), "btn-xs"];
        var hasChildren = hasOwnProp(a, "actions") && isArray(a.actions);

        btnHtml.push(generateMainTrigger($.extend({}, a, { btnCls: btnCls, hasChildren: hasChildren })));

        if (hasChildren) {
          btnHtml.unshift("<div class=\"btn-group btn-group-xs\">");
          btnHtml.push(generateDropdownMenu($.extend({}, a, { btnCls: btnCls })));
          btnHtml.push("</div>");
        }

        return btnHtml.join("");
      } else {
        return "";
      }
    });

    if (actions.length > 1 || wrapped === true) {
      html.unshift("<div class=\"OperationGroup\">");
      html.push("</div>");
    }

    return html.join("");
  },
  option: function option() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var extra = arguments[2];
    var selected = arguments[3];

    var attrs = ["class=\"is-dynamic\"", "value=\"" + value + "\""];

    if ($.isPlainObject(extra)) {
      $.each(extra, function (k, v) {
        attrs.push("data-" + k + "=\"" + v + "\"");
      });
    } else {
      selected = extra;
    }

    if (selected === true) {
      attrs.push("selected");
    }

    return "<option " + attrs.join(" ") + ">" + text + "</option>";
  }
};

defaults.uploader = {
  selector: ".js-uploadImage",
  limit: 0,
  draggable: true
};

function setImageItemUrl($item, url) {
  $("a", $item).attr("href", url || "javascript:void(0);");
  $("img", $item).attr("src", url);
}

function stashQiniuUploaderEvents(evts) {
  var result = {
    qiniu: {},
    stashed: {}
  };

  if (evts) {
    arrayEach(["FilesAdded", "BeforeUpload", "FileUploaded"], function (name) {
      if (isFunction(evts[name])) {
        result.stashed[name] = evts[name];

        delete evts[name];
      }
    });
  }

  result.qiniu = evts;

  return result;
}

function resolveUploader(settings, opts) {
  settings = $.extend(true, { multi_selection: false }, settings);

  var isDynamicUrl = isFunction(settings.url);

  if (isDynamicUrl) {
    settings.url = "dynamicUrlPlaceholder";
  }

  var uploader = void 0;

  if (settings.uptoken) {
    if (!settings.runtimes) {
      settings.runtimes = "html5,flash,html4";
    }

    var processed = stashQiniuUploaderEvents(settings.init);

    settings.init = processed.qiniu;

    uploader = Qiniu.uploader(settings);

    uploader.__muu = processed.stashed;

    uploader.bind("FileUploaded", function (up, file, result) {
      setImageItemUrl($("[data-file-id=\"" + file.id + "\"]"), "" + up.getOption("domain") + JSON.parse(result.response).key);
    });
  } else {
    uploader = new plupload.Uploader(settings);

    uploader.bind("FileUploaded", function (up, file, result) {
      if (isFunction(opts.getImageUrl)) {
        setImageItemUrl($("[data-file-id=\"" + file.id + "\"]"), opts.getImageUrl(JSON.parse(result.response)));
      }
    });

    uploader.init();
  }

  uploader.bind("FilesAdded", function (up, files) {
    if (isDynamicUrl) {
      uploader.setOption("url", settings.url());
    }
  });

  uploader.bind("BeforeUpload", function (up, file) {
    $("[data-file-id=\"" + file.id + "\"]").addClass("is-uploading");
  });

  uploader.bind("FileUploaded", function (up, file) {
    $("[data-file-id=\"" + file.id + "\"]").removeClass("is-uploading");
  });

  return uploader;
}

function initSingleImageUploader(settings, opts) {
  var uploader = resolveUploader(settings, opts);

  uploader.bind("FilesAdded", function (up, files) {
    var $item = $(settings.browse_button).siblings(".ImageItem");
    var file = files[0];

    setImageItemUrl($item, "");

    $item.removeClass("is-empty").attr("data-file-id", file.id);
  });

  return uploader;
}

function initMultipleImageUploader(settings, opts) {
  var uploader = resolveUploader(settings, opts);

  uploader.bind("FilesAdded", function (up, files) {
    var $btn = $(settings.browse_button);
    var $el = $btn.closest(".ImageList").parent();

    arrayEach(files, function (file) {
      utils.generate.imageItem({
        $btn: $btn,
        $el: $el,
        text: file.name,
        column: opts.column,
        max: opts.limit,
        removable: true,
        callback: function callback($newCol, $btnCol) {
          $(".ImageItem", $newCol).attr("data-file-id", file.id);

          if (isFunction(opts.imageItemAdded)) {
            opts.imageItemAdded.call(null, $newCol, $btnCol);
          }
        }
      });
    });
  });

  return uploader;
}

utils.upload = {
  image: function image($btn, opts) {
    var initializer = void 0,
        uploader = void 0;

    $btn = $($btn);
    opts = $.extend(true, {
      limit: defaults.uploader.limit,
      draggable: defaults.uploader.draggable,
      settings: null
    }, opts);

    if ($.isPlainObject(opts.settings)) {
      var defaultSettings = {
        browse_button: $btn.get(0),
        filters: {
          mime_types: [{
            title: "图片文件",
            extensions: "jpeg,jpg,png,gif"
          }]
        }
      };

      if (opts.draggable === true) {
        defaultSettings.drop_element = $btn.get(0);
      }

      if ($btn.siblings(".ImageItem").length > 0) {
        initializer = initSingleImageUploader;
        opts.settings.multi_selection = false;
      } else {
        initializer = initMultipleImageUploader;
      }

      uploader = initializer($.extend(true, defaultSettings, opts.settings), opts);

      if (hasOwnProp(uploader, "__muu")) {
        arrayEach(objectKeys(uploader.__muu), function (name) {
          uploader.bind(name, uploader.__muu[name]);
        });

        delete uploader.__muu;
      }
    }

    return uploader;
  }
};

defaults.table = {
  selector: "",
  showRowNumber: false,
  rowActions: [],
  keys: {
    sort: "sortBy",
    order: "orderBy"
  },
  responseHandler: function responseHandler() {}
};

function getDataTable() {
  return $(defaults.table.selector);
}

try {
  defaults.table.responseHandler = $.fn.bootstrapTable.defaults.responseHandler;
} catch (e) {}

function sliceUrlQueryString(url) {
  var el = document.createElement("a");

  el.setAttribute("href", url);

  return el.search.slice(1);
}

function queryString2Json(str) {
  var jsonData = {};

  arrayEach(str.split("&"), function (pair) {
    pair = pair.split("=");
    jsonData[pair[0]] = decodeURIComponent(pair[1]);
  });

  return jsonData;
}

function resolveTableOptions(opts) {
  var url = opts.url,
      ajaxOptions = opts.ajaxOptions;


  ajaxOptions = $.extend(true, {}, $.fn.bootstrapTable.defaults.ajaxOptions, ajaxOptions);
  opts.columns = utils.table.columns(opts.columns, opts.showRowNumber);

  if (!url) {
    url = ajaxOptions.url;
    delete ajaxOptions.url;
  }

  if (isFunction(url)) {
    var beforeSend = ajaxOptions.beforeSend;
    var urlMaker = url;

    url = "AJAX_URL_PLACEHOLDER";

    ajaxOptions.beforeSend = function (jqXHR, ajaxSettings) {
      ajaxSettings.url = urlMaker(queryString2Json(ajaxSettings.data || sliceUrlQueryString(ajaxSettings.url)));

      if (isFunction(beforeSend)) {
        return beforeSend.apply(null, [jqXHR, ajaxSettings]);
      }
    };
  }

  return $.extend(true, opts, { url: url, ajaxOptions: ajaxOptions });
}

utils.table = {
  init: function init($table, opts) {
    if ($.isPlainObject($table)) {
      opts = $table;
      $table = null;
    }

    if (!$table) {
      $table = getDataTable();
    }

    opts = resolveTableOptions(opts);

    var _opts = opts,
        lazy = _opts.lazy,
        url = _opts.url;


    if (lazy === true) {
      delete opts.lazy;
      delete opts.url;
    }

    $table.bootstrapTable(opts);

    if (lazy === true) {
      $table.data("bootstrap.table").options.url = url;
    }
  },
  columns: function columns(cols, showRowNumber) {
    var temp = isArray(cols) ? cols.concat([]) : [];

    if ($.type(showRowNumber) !== "boolean") {
      showRowNumber = defaults.table.showRowNumber;
    }

    if (showRowNumber === true) {
      temp.unshift({
        field: "serialNumber",
        title: "序号",
        align: "center",
        formatter: function formatter(val, row, idx) {
          return ++idx;
        }
      });
    }

    return arrayMap(temp, function (col) {
      var viewDetailOpts = col.viewDetail;
      var dateTimeFormatter = col.dateTimeFormatter;
      var rawFormatter = col.formatter;

      if ($.isPlainObject(viewDetailOpts)) {
        col.formatter = function (val) {
          if (isFunction(rawFormatter)) {
            val = rawFormatter.apply(null, toArray(arguments));
          }

          return "<a href=\"javascript:void(0);\" class=\"js-openDetailDialog\">" + (val || "-") + "</a>";
        };

        col.events = $.extend({}, col.events, {
          "click .js-openDetailDialog": function clickJsOpenDetailDialog(e, val, row) {
            utils.ajax.get(viewDetailOpts.url, viewDetailOpts.params(val, row), function (result) {
              var $m = $(".js-viewDetail");

              if (isFunction(viewDetailOpts.handler)) {
                viewDetailOpts.handler.apply(null, [val, row, result, $m]);
              } else {
                utils.field.fill($m, result);
              }

              $m.modal("show");
            });
          }
        });
      }
      else if (dateTimeFormatter) {
          col.formatter = function (val) {
            if (dateTimeFormatter === true) {
              dateTimeFormatter = "YYYY-MM-DD HH:mm:ss";
            }

            return isString(dateTimeFormatter) && moment ? moment(val).format(dateTimeFormatter) : isFunction(dateTimeFormatter) ? dateTimeFormatter.call(this, val) : val;
          };
        }

      col.titleTooltip = col.title;

      return col;
    });
  },
  refresh: function refresh() {
    var $table = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDataTable();
    var resetTop = arguments[1];

    if ($.type($table) === "boolean") {
      resetTop = $table;
      $table = getDataTable();
    }

    if (resetTop === true) {
      $table.data("bootstrap.table").options.pageNumber = 1;
    }

    $table.bootstrapTable("refresh");
  }
};

function initDefaults() {
  arrayEach([{
    dependency: SUPPORTS.BS_MODAL,
    initializer: function initializer() {
      $.extend($.fn.modal.Constructor.DEFAULTS, {
        backdrop: "static",
        keyboard: false
      });
    }
  }, {
    dependency: SUPPORTS.BS_TABLE,
    initializer: function initializer() {
      $.extend($.fn.bootstrapTable.defaults, {
        classes: "table table-condensed table-hover",
        iconsPrefix: "fa",
        icons: {
          refresh: "fa-refresh",
          toggle: "fa-list-alt",
          columns: "fa-th",
          detailOpen: "fa-plus",
          detailClose: "fa-minus"
        },
        iconSize: "sm",
        sidePagination: "server",
        pagination: true,
        pageSize: 20,
        pageList: [],
        cache: false,
        queryParams: function queryParams(params) {
          return utils.form.jsonify($(".Area--query form").serializeArray().concat({
            name: "pageSize",
            value: this.pageSize
          }, {
            name: "pageNo",
            value: this.pageNumber
          }, params.sort == null ? [] : [{
            name: defaults.table.keys.sort,
            value: params.sort
          }, {
            name: defaults.table.keys.order,
            value: params.order
          }]), function (jsonified) {
            arrayEach(objectKeys(jsonified), function (k) {
              jsonified[k] = jsonified[k].toString();
            });

            return jsonified;
          });
        },
        responseHandler: function responseHandler(res) {
          return defaults.table.responseHandler.call(this, res);
        },
        onPostBody: function onPostBody(data) {
          $(".detail-icon").closest("td").addClass("u-alignMiddle u-textCenter");
        }
      });

      $.extend($.fn.bootstrapTable.columnDefaults, { valign: "middle" });
    }
  }, {
    dependency: SUPPORTS.BS_DATETIME,
    initializer: function initializer() {
      $.extend(true, $.fn.datetimepicker.defaults, {
        locale: "zh-CN",
        icons: {
          time: "fa fa-clock-o",
          date: "fa fa-calendar",
          up: "fa fa-chevron-up",
          down: "fa fa-chevron-down",
          previous: "fa fa-chevron-left",
          next: "fa fa-chevron-right",
          today: "fa fa-crosshairs",
          clear: "fa fa-trash",
          close: "fa fa-remove"
        },
        showTodayButton: true
      });
    }
  }, {
    dependency: SUPPORTS.SELECT2,
    initializer: function initializer() {
      $.each({
        containerCssClass: "muu-Select2-container",
        dropdownCssClass: "muu-Select2-dropdown",
        minimumResultsForSearch: "Infinity"
      }, function (k, v) {
        $.fn.select2.defaults.set(k, v);
      });
    }
  }, {
    dependency: SUPPORTS.H5FX,
    initializer: function initializer() {
      H5F.rules({
        MOBILE: {
          rule: /^(0|86|17951)?(13[0-9]|15[012356789]|17[03678]|18[0-9]|14[57])[0-9]{8}$/,
          message: "NOT_A_MOBILE"
        }
      });

      H5F.errors({
        UNKNOWN_INPUT_TYPE: "{{LABEL}}为未知输入框类型",
        COULD_NOT_BE_EMPTY: "{{LABEL}}不能为空",
        LENGTH_SMALLER_THAN_MINIMUM: "{{LABEL}}应为{{MINLENGTH}}～{{MAXLENGTH}}个字符",
        LENGTH_BIGGER_THAN_MAXIMUM: "{{LABEL}}应为{{MINLENGTH}}～{{MAXLENGTH}}个字符",
        INVALID_VALUE: "{{LABEL}}不符合要求的格式",
        NOT_AN_ABSOLUTE_URL: "{{LABEL}}不是一个 URL 地址",
        NOT_AN_EMAIL: "{{LABEL}}不是一个邮箱",
        NOT_A_NUMBER: "{{LABEL}}不是一个数字",
        UNDERFLOW: "{{LABEL}}不能小于{{MIN}}",
        OVERFLOW: "{{LABEL}}不能大于{{MAX}}",
        DIFFERENT_VALUE: "{{LABEL}}所输入的字符要与{{ASSOCIATE_LABEL}}保持一致",
        AT_LEAST_CHOOSE_ONE: "请从{{LABEL}}中选择一项",
        SHOOLD_BE_CHOSEN: "请选中{{UNIT_LABEL}}",
        SHOOLD_CHOOSE_AN_OPTION: "必须选择{{LABEL}}",
        NOT_A_MOBILE: "{{LABEL}}不符合手机号码格式"
      });
    }
  }, {
    dependency: SUPPORTS.MOMENTJS,
    initializer: function initializer() {
      moment.locale("zh-CN");
    }
  }], function (lib) {
    if (lib.dependency()) {
      lib.initializer();
    }
  });
}

function initDialogs() {
  if (!SUPPORTS.BS_MODAL()) {
    return;
  }

  $(document).on("shown.bs.modal", ".modal", function () {
    var $m = $(this);
    var $dlg = $(".modal-dialog", $m);
    var $cnt = $(".modal-content", $m);

    utils.dialog.levelUp($m);

    if ($dlg.height() > $m.height()) {
      $m.addClass("is-scrollable");
      $cnt.css("height", $m.height() - parseFloat($dlg.css("margin-top"), 10) - parseFloat($dlg.css("margin-bottom"), 10) - parseFloat($cnt.css("border-top-width"), 10) - parseFloat($cnt.css("border-bottom-width"), 10));
    }
  });

  $(document).on("hidden.bs.modal", ".modal", function () {
    var $m = $(this);

    utils.dialog.levelDown($m);

    if ($m.hasClass("is-scrollable")) {
      $m.removeClass("is-scrollable");
      $(".modal-content", $m).css("height", "auto");
    }
  });
}

function initSelects() {
  if (!SUPPORTS.SELECT2()) {
    return;
  }

  $("select").select2();

  $(".modal select").on("select2:open", function () {
    $(this).data("select2").$dropdown.css("z-index", $(this).closest(".modal").css("z-index"));
  });
}

$(document).ajaxError(function () {
  var _defaults$ajax;

  (_defaults$ajax = defaults.ajax).errorHandler.apply(_defaults$ajax, arguments);
  resetWaitStatus();
});

$(document).ready(function () {
  initDefaults();
  initDialogs();
  initSelects();

  $("input[type='number']").on("mousewheel", function (e) {
    e.preventDefault();
  });

  $("body").on("click", ".js-removeUploadedImage", function () {
    var $btn = $(this);
    var $item = $btn.closest(".ImageItem");

    if ($item.siblings("button.ImageItem--add").length) {
      $item.addClass("is-empty").removeAttr("data-file-id");

      setImageItemUrl($item, "");
    } else {
      moveImageItemsForward($item);
    }
  });
});
return utils;
}));
